import styled, { css } from 'styled-components';
import { layout } from '../../../../package.json';

export const Container = styled.div`
  width: 100%;
`;

interface AddressRowProps {
  bDirectionColumn?: boolean
}

export const AddressRow = styled.div<AddressRowProps>`
  width: 100%;
  display: flex;

  margin-bottom: 10px;

  input.postcode {
    /* width: 200px !important; */
    height: 50px !important;
    border: 1px solid var(--primary);
    border-radius: 12px !important;
    font-size: 1rem !important;
    text-align: left;
    padding-left: 15px;
  }

  > div + div {
    margin-left:0.93rem;
  }

  @media (max-width: ${layout.tablet}) {
    ${
      props => props.bDirectionColumn && css`
        flex-direction: column;
        > div + div {
        margin-top: 10px;
        margin-left:0;
        }
      `
    }
  }

`;

export const MapContainer = styled.div`
  width: 100%;
  margin: 20px 0;
  padding: 15px;
  border: 1px solid #ddd;
  border-radius: 8px;
  background-color: #f9f9f9;
`;

export const MapWrapper = styled.div`
  width: 100%;
  height: 300px;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
`;

